import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Drawer, IconButton } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import EBSettings from '../EmploymentBillboard/Admin/App';
import GlobalSettings from '../EmploymentBillboard/Admin/GlobalConfigurations'
import Archive from '../EmploymentBillboard/Admin/Archive';
import { faTh } from '@fortawesome/pro-solid-svg-icons';
import { faTimes, faBars, faArchive, faListUl } from '@fortawesome/pro-light-svg-icons';
import { faBallotCheck, faSlidersH } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Provider } from 'react-redux';
import { adminStore as store } from '../EmploymentBillboard/store';
import ReduxToastr from 'react-redux-toastr';
import LogoutWarning from '../common/components/LogoutWarning';
import { getApp, productList, getProduct } from '../services/productList';
import { UserProfileMenu, NotMobileSupported } from '../common-client2/src/components';
import { Title as SidebarTitle, Content as SidebarContent } from '../common-client2/src/components/SidebarMenu';
import ActionIconButton from '../common-client2/src/components/ActionIconButton';
import SettingTitle from '../common/components/UI/Title/SettingTitle';
import axios from 'axios';
import { isMobile } from 'react-device-detect';


const adminApp = getApp('adminSettings');

const styles = () => ({
    root: {
        display: 'flex',
        height: '100vh',
    },
    fullHeight: {
        height: '100%'
    },
    textAlignCentered: {
        textAlign: 'center'
    },
    settingContainer: {
        width: '99%',
        paddingLeft: 20
    },
    drawerPaper: {
        width: '16%',
        backgroundColor: '#0a54a2',
        minWidth: 240
    },
    drawer: {
        flexShrink: 0,
        width: '16%',
        minWidth: 240
    },
    drawerPaperV2: {
        width: 320,
        backgroundColor: '#FFFFFF',
        minWidth: '320px'
    },
    drawerV2: {
        flexShrink: 0,
        zIndex: 2,
    },
    content: {
        flex: 1,
    },
    backdrop: {
        width: '100vw',
        height: '100vh',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1
    },
    contentWrapper: {
        position: 'relative'
    },
    topButtons: {
        display: 'flex',
        alignItems: "center",
        minHeight: 64,
        paddingLeft: 24,
        paddingRight: 24,
    },
    barsButton: {
        padding: 0,
        color: 'var(--N700)',
        '& svg': {
            width: 24,
            height: 32,
        },
    },
    titleSlot: {
        flex: 1,
        marginLeft: 20,
        marginTop: 4,
    }
});

const appIcon = {
    callList: ['fal', 'phone'],
    quotaManagement: ['fal', 'chart-pie'],
    requestCalendar: ['fal', 'calendar'],
    hcScheduleReport: ['fal', 'clock'],
    dailyShiftBidding: faBallotCheck,
    workplanManager: faTh,
    employmentBillboard: faTh,
    globalConfigurations: faSlidersH,
    archive: faArchive,
}

class AdminSettings extends Component {
    constructor(props) {
        super(props);

        const jwtUserInfo = JSON.parse(sessionStorage.getItem('jwtUserInfo'));
        const initiales = sessionStorage.getItem('userInitials');
        const firstName = jwtUserInfo?.FirstName ? jwtUserInfo?.FirstName : "";
        const lastName = jwtUserInfo?.LastName ? jwtUserInfo?.LastName : "";

        this.state = {
            applicationSelected: localStorage.getItem('appSelected') || getProduct("employmentBillboard").name,
            extended: false,
            buildInfos: {
                version: "-",
                environment: "-"
            },
            userInfos: {
                firstName: firstName,
                lastName: lastName,
                initials: initiales,
            }
        };

        this.apps = productList?.filter((p) => p?.env.includes("admin") && p?.api === adminApp.api);

        const options = {
            headers: {
                Authorization: sessionStorage.getItem('authToken') ?? '',
            }
        };
        axios.get(process.env.REACT_APP_API_DOTNET + '/api/v1/common/buildInfos', options).then(async buildInfos => {
            this.setState({ buildInfos: { ...buildInfos.data } })
        });
    }

    handleOnClickApplication = (name) => {
        this.setState({ applicationSelected: name, extended: false });
        localStorage.setItem('adminAppSelected', name);
    }

    handleSideMenu = (event, extend) => {
        event.stopPropagation()
        this.setState({ extended: extend })
    }

    renderDrawerV2(classes, applicationSelected) {
        const { t } = this.props;
        return (
            <Drawer
                className={classes.drawerV2}
                variant="persistent"
                classes={{ paper: classes.drawerPaperV2 }}
                anchor="left"
                open={this.state.extended}
            >
                <div className="core--sidebar-menu">
                    <SidebarTitle
                        title={t('employmentBillboard:navBar.appName')}
                        icon={<FontAwesomeIcon icon={faListUl} />}
                        onIconTitleClick={(event) => this.handleSideMenu(event, false)}
                    />
                    <SidebarContent>
                        {this.apps.map((app, index) => {
                            const isActive = app.name === applicationSelected;
                            return (
                                <ActionIconButton
                                    key={index}
                                    className={`menu-item ${isActive ? 'active' : ''}`}
                                    onClick={() => { this.handleOnClickApplication(app.name) }}
                                >
                                    <>
                                        {appIcon[app.name] && <FontAwesomeIcon icon={appIcon[app.name]} />}
                                        <label>{t(`${app.name}:navBar.appName`)}</label>
                                    </>
                                </ActionIconButton>
                            );
                        })}
                    </SidebarContent>
                </div>
            </Drawer>
        );
    }

    render() {
        if(isMobile){
            return (
                <NotMobileSupported/>
            )
        }

        const { classes, t } = this.props;
        const { applicationSelected, extended, userInfos, buildInfos } = this.state;
        const appComponent = {
            employmentBillboard: <EBSettings />,
            archive: <Archive />,
            globalConfigurations: <GlobalSettings />,
        }

        const appTitles = {
            employmentBillboard: {
                title: t('employmentBillboard:settings.adminPageHeader'),
                subtitle: t('employmentBillboard:settings.adminPageSubHeader'),
            },
            archive: {
                title: t('archive:header.adminPageHeader'),
                subtitle: t('archive:header.adminPageSubHeader'),
            },
            globalConfigurations: {
                title: t('globalConfigurations:settings.appName'),
                subtitle: t('globalConfigurations:settings.settings'),
            },
        };
        const currentTitle = appTitles[applicationSelected] || { title: '', subtitle: '' };

        const app = appComponent[applicationSelected];

        return (
            <Provider store={store}>
                <div className={classes.root}>
                    <div className={classes.content}>
                        <div className={classes.topButtons}>
                            <IconButton onClick={(event) => this.handleSideMenu(event, true)} size="small" className={classes.barsButton}>
                                <FontAwesomeIcon icon={faBars} />
                            </IconButton>
                            <SettingTitle
                                titleText={currentTitle.title}
                                subtitleText={currentTitle.subtitle}
                                wrapperClass={classes.titleSlot}
                            />
                            <UserProfileMenu
                                fullName={`${userInfos.firstName} ${userInfos.lastName}`}
                                initials={userInfos.initials}
                                version={buildInfos.version}
                                environement={t(`environment.${buildInfos.environment}`, { ns: 'common' })}
                                labels={{
                                    sectionTitleAbout: t(`userMenu.about`, { ns: 'common' }),
                                    aboutVersion: t(`userMenu.version`, { ns: 'common' }),
                                    aboutEnvironment: t(`userMenu.environment`, { ns: 'common' })
                                }}
                            />
                        </div>
                        {extended ? <div className={classes.backdrop} onClick={(event) => this.handleSideMenu(event, false)}></div> : null}
                        {this.renderDrawerV2(classes, applicationSelected)}
                        <div className={classes.contentWrapper}>
                            {app}
                        </div>
                    </div>
                </div>
                <ReduxToastr
                    timeOut={4000}
                    newestOnTop={false}
                    preventDuplicates
                    position="top-center"
                    transitionIn="fadeIn"
                    transitionOut="fadeOut"
                    closeOnToastrClick
                />
                <LogoutWarning />
            </Provider>
        );
    }
}

export default withTranslation(['common', 'employmentBillboard', 'archive', 'globalConfigurations', 'hcScheduleReport', 'workplanManager', 'quotaManagement', 'requestCalendar', 'dailyShiftBidding'])(withStyles(styles)(AdminSettings));